/**
 * Compare two Note objects for equality.
 *
 * Two notes are equal if they have the same noteName and modifier.
 * Enharmonic equivalents (F♯ vs G♭) are NOT equal.
 *
 * @param a - First Note object
 * @param b - Second Note object
 * @returns true if notes are equal, false otherwise
 */
export function equalNotes(a, b) {
    return a.noteName === b.noteName && a.modifier === b.modifier;
}
/**
 * Compare two Note objects for equality, with null handling.
 *
 * - null === null → true
 * - null === Note → false
 * - Note === null → false
 *
 * @param a - First Note object or null
 * @param b - Second Note object or null
 * @returns true if notes are equal, false otherwise
 */
export function equalNotesNullable(a, b) {
    if (a == null && b == null)
        return true;
    if (a == null || b == null)
        return false;
    return equalNotes(a, b);
}
/**
 * Compare two KeySignature objects for equality.
 *
 * Two key signatures are equal if they have equal notes and the same mode.
 *
 * @param a - First KeySignature object
 * @param b - Second KeySignature object
 * @returns true if key signatures are equal, false otherwise
 */
export function equalKeySignatures(a, b) {
    return equalNotes(a.note, b.note) && a.mode === b.mode;
}
/**
 * Compare two KeySignature objects for equality, with null handling.
 *
 * - null === null → true
 * - null === KeySignature → false
 * - KeySignature === null → false
 *
 * @param a - First KeySignature object or null
 * @param b - Second KeySignature object or null
 * @returns true if key signatures are equal, false otherwise
 */
export function equalKeySignaturesNullable(a, b) {
    if (a == null && b == null)
        return true;
    if (a == null || b == null)
        return false;
    return equalKeySignatures(a, b);
}
